// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__uFQYj","logoContainer":"Logo_logoContainer__cFRjW","mobileLogoContainer":"Logo_mobileLogoContainer__moWqp"};